<!--
 * @description: list
 * @author: 06455
 * @date: 2023/12/6 15:42
-->
<template>
  <div>
    <ls-table-layout>
      <template #search>
        <search-input ref="searchInput" @onSearch="search" :status="billStatus" />
      </template>
      <template #tabs>
        <ls-button-group
          class="indexTabs"
          type="tabs"
          :current="billStatus"
          :buttonItem="buttonItem"
          @select="tabsClick"
          v-if="buttonShow"
        >
        </ls-button-group>
      </template>
      <template #btn>
        <a-space>
          <a-button key="autoPlay" type="primary" :loading="autoBtnLoading" @click="autoPlay" v-if="createStatus&&$hasPermi(['fun_119800_mVBHO'])">自动计算</a-button>
          <a-button key="reviewedStatus_factoryAddAudit" type="primary" @click="factoryAddAudit" v-if="$hasPermi(['fun_119800_jzSbm'])&&(reviewedStatus||showStatus)">增货审核</a-button>
          <a-button key="reviewBill_reviewStatus" type="primary" @click="reviewBill" v-if="reviewStatus&&$hasPermi(['fun_119800_yYMgj'])">审核</a-button>
          <a-button key="addBill" @click="addBill" :disabled="autoBtnLoading" v-if="createStatus&&$hasPermi(['fun_119800_dMmly'])">新增</a-button>
          <a-button key="submit" @click="submit" v-if="createStatus&&$hasPermi(['fun_119800_lBIAs'])">提交</a-button>
          <a-button key="reviewedStatus_cancelQty" @click="cancelQty" v-if="reviewedStatus&&$hasPermi(['fun_119800_GfohN'])">取消数量</a-button>
          <a-button key="reviewedStatus_pushDown" @click="pushDown" v-if="reviewedStatus&&$hasPermi(['fun_119800_bbSPr'])">推送</a-button>
          <a-button key="rejectBill_reviewStatus" v-if="(reviewStatus||reviewedStatus)&&$hasPermi(['fun_119800_kyxEz'])" @click="rejectBill" >驳回</a-button>
          <a-button key="cancelBill" @click="cancelBill" v-if="(createStatus||reviewedStatus)&&$hasPermi(['fun_119800_xFxzV'])">作废</a-button>
          <a-button key="importHandler" @click="importHandler" v-if="createStatus&&$hasPermi(['fun_119800_dPKFY'])">导入</a-button>
          <a-button key="handleExport" @click="handleExport" :loading="loading" v-if="(createStatus||reviewedStatus||cancelStatus||showStatus||allStatus)&&$hasPermi(['fun_119800_UFBuP'])">导出</a-button>
          <a-button key="batchUpdateRow" @click="batchUpdateRow" v-if="createStatus&&$hasPermi(['fun_119800_xHMuy'])">批量修改</a-button>
          <a-button key="batchReviewDate" @click="batchReviewDate" v-if="createStatus&&$hasPermi(['fun_119800_SoIOG'])">批量修改要求到货日期</a-button>
          <a-button key="addBill" @click="addHardwareBill" :disabled="autoBtnLoading" v-if="createStatus">新增五金箱</a-button>
          <a-button
            key="splitBill"
            @click="onSplitBill"
            v-if="reviewedStatus && $hasPermi(['fun_119800_XNZhJ'])"
            :loading="splitLoading"
          >拆分</a-button>
        </a-space>
      </template>
      <template #table>
        <ls-api-table
          ref="baseTable"
          class="baseTable"
          :columns="columns"
          :table-props="tableProps"
          :selectedRows.sync="selectedRows"
          :pagination="pagination"
          :multi-select="true"
          :scroll="{ fixScreen: true, x: 1200 , extraHeight: 80 }"
          :custom-selection="{ stickyFixed: true,columnWidth:61 }"
          :row-class-name="getRowClassName"
          @change="sortFun"
          bordered
        >
          <template #factoryName="{ record }">
            <a v-if="createStatus" @click="updateRow(record)">{{ record.factoryName }}</a>
            <span v-else>{{ record.factoryName }}</span>
          </template>
          <!--要求到仓数-->
          <template #requireDeliveryQuantity="{ text, record, index }">
            <template v-if="record.planSourceType === 0 && billStatus === 10">
              <template v-if="record.requireDeliveryQuantityEditable">
                <a-input-number
                  v-model="record.requireDeliveryQuantity"
                  :min="0"
                  :max="99999"
                  :parser="(value) => `${value}`.replace(/\D/g, '')"
                  :formatter="(value) => `${value}`.replace(/\D/g, '')"
                  @change="(e) => changeRequireDeliveryQuantity(e, record)"
                  @blur="(e) => requireDeliveryQuantityBlur(e, record)"
                />
              </template>
              <template v-else>
                <a @click="clickEditable(record)">{{ record.requireDeliveryQuantity || 0 }}</a>
              </template>
            </template>
            <template v-else>
              <span>{{ record.requireDeliveryQuantity || 0 }}</span>
            </template>
          </template>
          <!--审核数量-->
          <template #auditQuantity="{ text, record }">
            <template v-if="record.rowType === 11 || record.rowType === 12">
              <a-input-number
                @change="(e) => changeAuditQuantity(e, record)"
                v-model="record.auditQuantity"
                :max="record.supplementQuantity"
                :min="0"
                :disabled="record.status !== 25"
              ></a-input-number>
            </template>
          </template>
          <!--当前订单满足率-->
          <template #curOrderSatisfyRate="{text}">{{ fix2NumPercentFun(text) }}</template>
          <!--当前订单满足率-->
          <template #curOrderSatisfyRateTitle>
            <span class="marginRight">当前订单满足率</span>
            <a-tooltip placement="top" title="当前可用数/客审未货审订单">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--客审未货审订单-->
          <template #orderQtyTitle>
            <span class="marginRight">客审未货审订单</span>
            <a-tooltip placement="top" title="取每天BI报表的数据，若当日BI报表生成有问题则延用前一天获取的数据">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--送货体积-->
          <template #deliveryVolumeTitle>
            <span class="marginRight">送货体积</span>
            <a-tooltip placement="top" title="计划到仓数量*标准体积 或 增货数量*标准体积">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--安排体积-->
          <template #arrangeVolumeTitle>
            <span class="marginRight">安排体积</span>
            <a-tooltip placement="top" title="已安排数量*标准体积 或 审核数量*标准体积">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--剩余入库数量-->
          <template #surplusInStockQuantityTitle>
            <span class="marginRight">剩余入库数量</span>
            <a-tooltip placement="top" title="原要求到仓数-取消数量-已入库数">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--已入库数量-->
          <template #orderQtyTitle>
            <span class="marginRight">已入库数量</span>
            <a-tooltip placement="top" title="4PL ODS调度中心库存">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--已安排数量-->
          <template #arrangeQuantityTitle>
            <span class="marginRight">已安排数量</span>
            <a-tooltip placement="top" title="除了状态为“已取消”的收货单汇总">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--未安排数量-->
          <template #unArrangeQuantityTitle>
            <span class="marginRight">未安排数量</span>
            <a-tooltip placement="top" title="要求到仓数-已安排数量">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <!--本次超出数量-->
          <template #curOverageQuantityTitle>
            <span class="marginRight">本次超出数量</span>
            <a-tooltip placement="top" title="要求到仓数-安全库存水位">
              <a-icon type="info-circle" />
            </a-tooltip>
          </template>
          <template slot="footer">
            <a-table
              bordered
              :row-key="(record, index) => index"
              :showHeader="false"
              class="footerTable"
              :columns="footerTableColumns"
              :data-source="sumInfoList"
              :pagination="false"
            >
              <template #summation>
                <span>合计</span>
              </template>
            </a-table>
          </template>
        </ls-api-table>
      </template>
    </ls-table-layout>
    <add-modal ref="addModal" @addSuccess="search()" />
    <hw-add-modal ref="hwAddModal" @addSuccess="search()" />
    <edit-modal ref="editModal" @editSuccess="search()" />
    <review-date-modal ref="reviewDateModal" @submitSuccess="search()" />
    <!--导入发货单结果-->
    <import-result
      ref="importResult"
      :importFileReadFunc="apiReceiptPlanImportRead"
      :importApiFunc="apiReceiptPlanImportAdd"
      @successCall="search()"
      :apiGetErrorFile="apiReceiptPlanErrorExport"
    >
      <import-table-vue slot="errorTable" slot-scope="{ dataList }" :dataList="dataList" tableType="error" />
      <import-table-vue slot="successTable" slot-scope="{ dataList }" :dataList="dataList" />
    </import-result>
    <!--自动计算弹窗-->
    <auto-computed-modal ref="autoComputedModal" @click="getLoading"/>
    <!--拆分弹窗-->
    <SplitModal ref="splitModalRef" @changeLoading="onChangeLoading" />
  </div>
</template>

<script>
import {
  BILLTYPE,
  RECEIPTS_STATUS,
  LOCATION_OCCUPANCY_STATUS,
  COMPLETE_STATUS,
  YES_OR_NO,
  INTERNAL_EXCLUSIVE_MAP,
  COMPLETE_STATUS_MAP,
  MORNING_OR_EVENING, CREATE_IS
} from './enum'
import {
  apiReceiptPlanAudit,
  apiReceiptPlanInvalid,
  apiReceiptPlanList,
  apiReceiptPlanReject,
  apiReceiptPlanSave,
  apiReceiptPlanSubmit,
  apiReceiptPlanWarehouse,
  apiReceiptPlanFactoryAddAudit,
  apiReceiptPlanCancelQty,
  apiReceiptPlanImportAdd,
  apiReceiptPlanErrorExport,
  apiReceiptPlanImportRead,
  apiReceiptPlanExport,
  // apiReceiptPlanAutoCalculate,
  apiReceiptPlanPushDown,
  apiReceiptPlanSum
} from '@/services/module/receiving-plan'
import SearchInput from '@/views/mes/scheduling-plan/receiving-plan/components/search-input'
import AddModal from '@/views/mes/scheduling-plan/receiving-plan/components/add-modal'
import HwAddModal from '@/views/mes/scheduling-plan/receiving-plan/components/hw-add-modal'
import EditModal from '@/views/mes/scheduling-plan/receiving-plan/components/edit-modal'
import ImportResult from './components/import-result.vue'
import ImportTableVue from './components/import-table.vue'
import ReviewDateModal from '@/views/mes/scheduling-plan/receiving-plan/components/review-date-modal'
import { generateLsTableResData } from '@/utils/util.js'
import { fixedTable } from "lsmy-libs";
import AutoComputedModal from "./components/auto-computed-modal.vue"
import SplitModal from './components/split-modal.vue';

export default {
  // eslint-disable-next-line
  name: 'Receiving-plan', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    ReviewDateModal,
    AddModal,
    HwAddModal,
    SearchInput,
    ImportResult,
    ImportTableVue,
    EditModal,
    AutoComputedModal,
    SplitModal
  },
  mixins: [
    fixedTable
  ],
  computed: {
    // 新创建
    createStatus () {
      return this.billStatus === RECEIPTS_STATUS.create.key
    },
    // 审核中
    reviewStatus () {
      return this.billStatus === RECEIPTS_STATUS.review.key
    },
    // 已审核
    reviewedStatus () {
      return this.billStatus === RECEIPTS_STATUS.reviewed.key
    },
    // 已作废
    cancelStatus () {
      return this.billStatus === RECEIPTS_STATUS.cancel.key
    },
    // 全部
    allStatus () {
      return this.billStatus === -1 && this.rowType === null
    },
    // 显示增货单
    showStatus () {
      return this.billStatus === -1 && this.rowType === 11
    },
    footerTableColumns () {
      return [
        {
          title: '勾选',
          align: 'center',
          width: 60,
          stickyFixed: 'left'
        },
        {
          title: '合计',
          scopedSlots: { customRender: 'summation' },
          align: 'center',
          width: 40,
          stickyFixed: 'left'
        },
        ...this.columns.slice(1)
      ]
    }
  },
  data () {
    return {
      BILLTYPE,
      RECEIPTS_STATUS,
      LOCATION_OCCUPANCY_STATUS,
      COMPLETE_STATUS,
      YES_OR_NO,
      MORNING_OR_EVENING,
      formData: {},
      buttonShow: true,
      columns: [
        {
          title: '序号',
          dataIndex: 'serialNumber',
          align: 'center',
          width: 40,
          stickyFixed: 'left',
          ellipsis: true
        },
        { dataIndex: 'factoryName', scopedSlots: { customRender: 'factoryName' }, title: '供应商', width: 230, stickyFixed: 'left' },
        { dataIndex: 'billNo', title: '计划单号', width: 155 },
        {
          dataIndex: 'status',
          title: '单据状态',
          width: 65,
          customRender: (text) => (!this.isNull(text) ? RECEIPTS_STATUS[text] : '')
        },
        {
          dataIndex: 'completeStatus',
          title: '完成状态',
          width: 60,
          customRender: (text) => (!this.isNull(text) ? COMPLETE_STATUS_MAP[text] : '')
        },
        {
          dataIndex: 'dischargeIs',
          title: '是否仓库卸货',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        {
          dataIndex: 'inspectionAtWarehouse',
          title: '是否到仓验货',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        {
          dataIndex: 'newProductIs',
          title: '是否新品',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        {
          dataIndex: 'deliveryProductFlag',
          title: '是否快递产品',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        { dataIndex: 'materialNo', title: '物料编码', width: 120 },
        { dataIndex: 'materialName', title: '物料名称', width: 100 },
        { dataIndex: 'materialSpec', title: '规格描述', width: 150, ellipsis: true },
        { dataIndex: 'requireDeliveryDay', title: '要求到货日期', width: 100 },
        {
          dataIndex: 'requireDeliveryQuantity',
          scopedSlots: { customRender: 'requireDeliveryQuantity' },
          title: '要求到仓数',
          width: 60
        },
        { dataIndex: 'originalRequireDeliveryQuantity', title: '计划到仓数', width: 60 },
        {
          dataIndex: 'internalExclusiveIs',
          title: '是否独占(内外部)',
          customRender: (text) => (!this.isNull(text) ? INTERNAL_EXCLUSIVE_MAP[text] : ''),
          ellipsis: true,
          width: 100
        },
        {
          dataIndex: 'supplierExclusiveIs',
          title: '是否独占(单工厂)',
          customRender: (text) => YES_OR_NO[text],
          width: 60
        },
        { dataIndex: 'supplementQuantity', title: '增货数量', width: 60 },
        {
          dataIndex: 'auditQuantity',
          title: '审核数量',
          scopedSlots: { customRender: 'auditQuantity' },
          width: 60
        },
        {
          dataIndex: 'arrangeVolume',
          // title: '安排体积',
          scopedSlots: { title: 'arrangeVolumeTitle' },
          width: 60
        },
        {
          dataIndex: 'deliveryVolume',
          // title: '送货体积',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: 'deliveryVolumeTitle' },
          width: 80
        },
        { dataIndex: 'cancelQuantity', title: '取消数量', width: 60 },
        {
          dataIndex: 'surplusInStockQuantity',
          // title: '剩余入库数量',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: 'surplusInStockQuantityTitle' },
          width: 80
        },
        { dataIndex: 'warehouseName', title: '入库仓库', ellipsis: true, width: 90 },
        { dataIndex: 'factoryWarehouseName', title: '供应商仓库', width: 100, ellipsis: true },
        { dataIndex: 'presetLoadVolume', title: '预设装载体积', width: 60 },
        { dataIndex: 'depositAreaName', title: '存放区域', width: 100, ellipsis: true },
        { dataIndex: 'locationQuantity', title: '库位数', width: 60 },
        { dataIndex: 'qtyPerLocation', title: '标准库位套数', width: 60 },
        {
          dataIndex: 'curOrderSatisfyRate',
          // title: '当前订单满足率',
          scopedSlots: { customRender: 'curOrderSatisfyRate', title: 'curOrderSatisfyRateTitle' },
          // customRender: (text) => (!this.isNull(text) ? this.fix2NumPercent(text, '%') : ''),
          width: 60
        },
        // {
        //   dataIndex: 'orderQty',
        //   // title: '客审未货审订单',
        //   width: 180,
        //   sorter: true,
        //   sortDirections: ['ascend', 'descend'],
        //   scopedSlots: { title: "orderQtyTitle" }
        // },
        {
          dataIndex: 'sumOrderSatisfyRate',
          title: '累计安排订单满足率',
          customRender: (text) => (!this.isNull(text) ? this.fix2NumPercent(text, '%') : ''),
          width: 60
        },
        {
          dataIndex: 'inStockQuantity',
          // title: '已入库数量',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: "orderQtyTitle" },
          width: 80
        },
        {
          dataIndex: 'arrangeQuantity',
          // title: '已安排数量',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: "arrangeQuantityTitle" },
          width: 80
        },
        {
          dataIndex: 'unArrangeQuantity',
          // title: '未安排数量',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: "unArrangeQuantityTitle" },
          width: 80
        },
        { dataIndex: 'entruckQuantity', title: '装车数量', width: 60 },
        {
          dataIndex: 'curOverageQuantity',
          // title: '本次超出数量',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          scopedSlots: { title: "curOverageQuantityTitle" },
          width: 80
        },
        { dataIndex: 'sumOverageQuantity', title: '累计超出数量', width: 60 },
        {
          dataIndex: 'supplierPriorityLevel',
          title: '供应商入库优先级',
          sorter: true,
          sortDirections: ['ascend', 'descend'],
          width: 80
        },
        { dataIndex: 'parentBillNo', title: '增货计划单', width: 120 },
        { dataIndex: 'parentReceiptBillNo', title: '增货-送货单', width: 120 },
        { dataIndex: 'remark', title: '备注', width: 120, ellipsis: true },
        {
          dataIndex: 'loadRate',
          title: '装载率',
          sorter: true,
          width: 60,
          customRender: (text) => !this.isNull(text) ? this.fix2NumPercent(text, '%') : ''
        },
        {
          dataIndex: 'dataCreateTime',
          title: '创建时间',
          customRender: text => text ? this.$moment(text).format('YYYY-MM-DD HH:mm') : '',
          width: 130
        },
        {
          dataIndex: 'dataModifyTime',
          title: '更新时间',
          customRender: text => text ? this.$moment(text).format('YYYY-MM-DD HH:mm') : '',
          width: 130
        },
        { dataIndex: 'lastUpdateUserName', title: '操作人名称', width: 80 },
        { dataIndex: 'dispatcherNo', title: '调度员编码', width: 80 },
        { dataIndex: 'dispatcherName', title: '调度员', width: 70 },
        { dataIndex: 'purchaseUserName', title: '采购员', width: 70 },
        {
          dataIndex: 'earlyMorningDeliveryIs',
          title: '是否早班送货',
          customRender: (text) => MORNING_OR_EVENING[text],
          width: 60
        },
        {
          dataIndex: 'momAutoCreateIs',
          title: '计划单来源',
          customRender: (text) => CREATE_IS[text],
          width: 60
        }
      ],
      billStatus: 10,
      tableProps: {
        requestApi: generateLsTableResData(apiReceiptPlanList, true),
        pageCurrent: true
      },
      buttonItem: [
        { id: 10, name: '新创建' },
        { id: 15, name: '审核中' },
        { id: 20, name: '已审核' },
        { id: 99, name: '已作废' },
        { id: -1, name: '全部' },
        { id: 98, name: '显示增货单' }
      ],
      pagination: {
        pageSizeOptions: [ '100', '10', '20', '50' ]
      },
      selectedRows: [],
      // 列表按钮状态数组
      loading: false,
      splitLoading: false,
      warehouseList: [], // 入库仓库列表
      rowType: '', // 显示增货单需要的查询条件
      sumInfoList: [],
      billNo: undefined,
      autoBtnLoading: false
    }
  },
  provide () {
    return {
      warehouseList: () => this.warehouseList,
      factoryWarehouseList: () => this.factoryWarehouseList
    }
  },
  created () {
    this.getWarehouseList()
    const { billNo = '' } = this.$route.query
    if (billNo) {
      this.billStatus = -1
    }
  },
  mounted () {
    this.setScroll();
    this.stickyFixedColumns(this.footerTableColumns)
    const { billNo = '' } = this.$route.query
    this.billNo = billNo
    if (billNo) {
      this.searchByRoute()
    } else {
      this.search()
    }
  },
  activated() {
     const { billNo = '' } = this.$route.query
     this.billNo = billNo
     if (this.billNo) {
      this.billStatus = -1
       this.buttonShow = false
       this.$nextTick(() => {
         this.buttonShow = true
       })
     }
    this.searchByRoute()
  },

  methods: {
    // 拆分
    onSplitBill() {
      if(this.selectedRows.length !== 1) {
        return this.$message.warn('请选择一行数据进行操作');
      }
      this.$refs.splitModalRef.show(JSON.parse(JSON.stringify(this.selectedRows[0])));
    },
    // 改变拆分按钮loading状态
    onChangeLoading(status) {
      this.splitLoading = status;
    },
    // 搜索
    searchByRoute () {
      console.log('触发搜索', this.billNo)
      if (this.billNo) {
        this.$refs.searchInput.setFormValue({ billNo: this.billNo })
        this.search({ billNo: this.billNo })
      }
    },
    apiReceiptPlanImportAdd,
    apiReceiptPlanImportRead,
    apiReceiptPlanErrorExport,
    // 合并表格设置同步滚动
    setScroll () {
      // 同步表与footer滚动
      const dom = this.$refs.baseTable.$el.querySelectorAll('.ant-table-body')[0]
      dom.addEventListener('scroll', () => {
        this.$refs.baseTable.$el.querySelectorAll('.ant-table-body')[1].scrollLeft = dom.scrollLeft
      }, true)
    },
    getRowClassName (record) {
      const classNameMap = {
        11: 'table-blue-row',
        12: 'table-green-row'
      }
      return record?.rowType ? classNameMap[record.rowType] : ''
    },
    tabsClick (val) {
      if (val[0].id === 98) {
        this.billStatus = -1
        this.rowType = 11
        // 切换tab时清空单据状态
        this.$refs.searchInput.setFormDatastatus(undefined);
        this.search({
          ...this.formData,
          status: null
        })
      } else {
        this.rowType = null
        this.billStatus = val[0].id
        // 切换tab时清空单据状态或给默认值
        this.$refs.searchInput.setFormDatastatus(val[0].id === 20 ? 20 : undefined);
        this.search({
          ...this.formData,
          status: val[0].id !== -1 ? val[0].id : null
        })
      }
    },
    searchSum (params) {
      apiReceiptPlanSum(params).then(res => {
        this.sumInfoList = [res.data]
      })
    },
    search (params) {
      if (params) {
        this.formData = params
      }
      const query = {
        ...this.formData,
        status: this.formData.status ?? (this.billStatus !== -1 ? parseInt(this.billStatus) : null),
        rowType: this.rowType,
        orderBys: this.orderBys
      }
      this.$refs.baseTable.searchParams = query
      this.$refs.baseTable.getData()
      this.searchSum(query)
    },
    // 修改要求到仓数
    changeRequireDeliveryQuantity (e, record) {
      this.$set(record, 'requireDeliveryQuantity', e)
    },
    // 失焦触发保存接口
    requireDeliveryQuantityBlur (e, record) {
      apiReceiptPlanSave(record.billNo, record)
        .then((res) => {
          const { code, msg } = res
          if (code === 200) {
            this.search()
            this.$delete(record, 'requireDeliveryQuantityEditable')
            this.$message.success(msg)
          }
        })
    },
    // 点击状态
    clickEditable (record) {
      this.$set(record, 'requireDeliveryQuantityEditable', true)
    },
    // 编辑审核数量
    changeAuditQuantity (val, row) {
      if (row.orderQty) {
        row.sumOrderSatisfyRate = !this.isNull(val)
          ? this.fix2Num((val + (row.inventoryQty || 0)) / row.orderQty)
          : this.fix2Num((row.inventoryQty || 0) / row.orderQty)
      } else {
        row.sumOrderSatisfyRate = 0
      }
      // 累计安排订单满足率
      if (row.orderQty) {
        row.sumOrderSatisfyRate = !this.isNull(val)
          ? this.fix2Num((val + (row.inventoryQty || 0)) / row.orderQty)
          : this.fix2Num((row.inventoryQty || 0) / row.orderQty)
      } else {
        row.sumOrderSatisfyRate = 0
      }
      row.auditQuantity = val
      row.deliveryVolume = !this.isNull(val) ? this.fix2Num(val * row.materialVolume) : 0

      // 自动勾选这行
      this.$refs.baseTable.onKeepSelect(row, true)
    },
    // 批量勾选
    batchCheck (isRowData = false) {
      return new Promise((resolve) => {
        if (this.selectedRows.length === 0) {
          return this.$message.warning('请勾选单据进行操作')
        }
        if (isRowData) {
          resolve(this.selectedRows)
        } else {
          const billNoList = this.selectedRows.map((item) => {
            return item.billNo
          })
          resolve(billNoList)
        }
      })
    },
    // 自动计算
    autoPlay () {
      // const _this = this
      // this.$confirm({
      //   title: '确定要触发自动计算吗?',
      //   content: (
      //     <div class='redText'>请确认其他调度人员已关闭新增页面</div>
      //   ),
      //   okText: '确认',
      //   okType: 'primary',
      //   cancelText: '取消',
      //   onOk () {
      //     _this.autoBtnLoading = true
      //     apiReceiptPlanAutoCalculate().then((res) => {
      //       const { data, msg } = res
      //       if (data) {
      //         _this.$message.success(msg)
      //       }
      //     }).finally(() => {
      //       _this.autoBtnLoading = false
      //     })
      //   }
      // })
      this.$refs.autoComputedModal.show()
    },
    // 五金箱新增
    addHardwareBill() {
      this.$refs.hwAddModal.show()
    },
    // 新增
    addBill () {
      this.$refs.addModal.show()
    },
    // 提交
    async submit () {
      const billNoList = await this.batchCheck()
      apiReceiptPlanSubmit(billNoList).then((res) => {
        const { data, msg } = res
        if (data) {
          this.search()
          this.$message.success(msg)
        }
      })
    },
    // 审核
    async reviewBill () {
      const billNoList = await this.batchCheck()
      apiReceiptPlanAudit(billNoList).then((res) => {
        const { data, msg } = res
        if (data) {
          this.search()
          this.$message.success(msg)
        }
      })
    },
    // 推送
    async pushDown () {
      const billNoList = await this.batchCheck()
      apiReceiptPlanPushDown(billNoList).then((res) => {
        const { data, msg } = res
        if (data) {
          this.search()
          this.$message.success(msg)
        }
      })
    },
    // 驳回
    async rejectBill () {
      const billNoList = await this.batchCheck()
      apiReceiptPlanReject(billNoList).then((res) => {
        const { data, msg } = res
        if (data) {
          this.search()
          this.$message.success(msg)
        }
      })
    },
    // 增货审核
    async factoryAddAudit () {
      const billNoList = await this.batchCheck(true)
      apiReceiptPlanFactoryAddAudit(billNoList).then((res) => {
        const { data, msg } = res
        if (data) {
          this.search()
          this.$message.success(msg)
        }
      })
    },
    // 取消数量
    async cancelQty () {
      const billNoList = await this.batchCheck()
      apiReceiptPlanCancelQty(billNoList).then((res) => {
        const { data, msg } = res
        if (data) {
          this.search()
          this.$message.success(msg)
        }
      })
    },
    // 作废
    async cancelBill () {
      const _this = this
      const billNoList = await this.batchCheck()
      this.$confirm({
        title: '确定作废吗？',
        okText: '确认',
        okType: 'primary',
        cancelText: '取消',
        onOk() {
          apiReceiptPlanInvalid(billNoList).then((res) => {
            const { data, msg } = res
            if (data) {
              _this.search()
              _this.$message.success(msg)
            }
          })
        }
      })
    },
    // 导入
    importHandler () {
      this.$refs.importResult.show()
    },
    updateRow (record) {
      this.$refs.editModal.show([record])
    },
    // 批量修改
    async batchUpdateRow () {
      const billNoList = await this.batchCheck(true)
      this.$refs.editModal.show(billNoList)
    },
    // 批量修改到货日期
    batchReviewDate () {
      if (this.selectedRows.length >= 2) {
        this.$refs.reviewDateModal.show(this.selectedRows)
      } else {
        this.$message.warning('请勾选至少两条单据进行操作')
      }
    },
    // 导出
    handleExport () {
      this.$message.loading({ content: '导出中...' })
      apiReceiptPlanExport(
        {
          ...this.formData,
          status: parseInt(this.billStatus)
        },
        `收货计划_${new Date().getTime()}.xlsx`
      )
        .then(() => {
          this.$message.destroy()
          this.$message.success('导出成功')
        })
        .catch(() => {
          this.$message.destroy()
          this.$message.error('导出失败')
        })
    },
    handleColumnXUpdate (newX, index) {
      // 更新列的x坐标
      this.columns[index].x = newX
    },
    handleColumnWidthUpdate (newWidth, index) {
      // 更新列的宽度
      this.columns[index].width = newWidth
    },
    // 获取入库仓库
    getWarehouseList () {
      apiReceiptPlanWarehouse().then((res) => {
        const rows = res.rows || []
        this.warehouseList = rows.map((item) => {
          return {
            key: item.warehouseCode,
            label: item.warehouseName
          }
        })
      })
    },
    // 后端排序
    sortFun (p, f, { field, order }) {
      this.orderBys = [
        {
          order: order,
          property: field
        }
      ]
      const searchParams = this.$refs.baseTable.searchParams // 历史查询参数
      const query = {
        // ...this.formData,
        ...searchParams,
        orderBys: this.orderBys,
        isUnderShipment: this.isUnderShipment
      }
      delete query.searchFormLabel
      this.$refs.baseTable.searchParams = query
    },
    // 转换方法
    isNullFun (text) {
      return this.isNull(text)
    },
    // 转换方法
    fix2NumPercentFun (text) {
      return this.fix2NumPercent(text, '%')
    },
    // 转换自动计算按钮loading
    getLoading(val) {
      this.autoBtnLoading = val
    }
  }
}
</script>

<style lang="less" scoped>
@import './styles/footerTable.less';
.indexTabs {
  ::v-deep .ant-tabs-bar {
    margin: 0 0 8px 0;
    border-bottom: 1px solid #e8e8e8;
  }
  ::v-deep .ant-tabs-nav .ant-tabs-tab {
    margin-right: 0;
  }
}

.baseTable {
  ::v-deep .table-blue-row {
    background-color: #d0e5fc;

    .sticky-columns {
      background-color: #d0e5fc;
    }
  }

  ::v-deep .table-green-row {
    background-color: #d5e9de;

    .sticky-columns {
      background-color: #d5e9de;
    }
  }

}
::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
  padding: 4px;
}
.footerTable {
  ::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
    padding: 4px;
  }
}
.marginRight{
  margin-right: 8px;
}
.redText{
  color:red
}

</style>
